import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { OrganizationApiKeyService } from '@core/services/entities/organization-api-key.service';
import { CreateOrganizationApiKeyRequestDto } from '@domain/organization-api-key/dtos/create-organization-api-key.request.dto';
import { ListOrganizationApiKeyRequestDto } from '@domain/organization-api-key/dtos/list-organization-api-key.request.dto';
import { OrganizationApiKeyResponseDto } from '@domain/organization-api-key/dtos/organization-api-key.response.dto';
import { OrganizationApiKeyRepository } from '@domain/organization-api-key/repositories/organization-api-key.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganizationApiKeyRepositoryService
  implements OrganizationApiKeyRepository
{
  constructor(private organizationApiKeyService: OrganizationApiKeyService) {}

  list(
    request: ListOrganizationApiKeyRequestDto,
  ): Observable<ApiResponse<OrganizationApiKeyResponseDto[]>> {
    return this.organizationApiKeyService.list(request);
  }

  create(
    request: CreateOrganizationApiKeyRequestDto,
  ): Observable<ApiResponse<OrganizationApiKeyResponseDto>> {
    return this.organizationApiKeyService.create(request);
  }

  revoke(request: RefId): Observable<ApiResponse<OrganizationApiKeyResponseDto>> {
    return this.organizationApiKeyService.revoke(request);
  }
}
